export const DEFAULT_SORT_JSON = Object.freeze({
  projectListOrder: '-updated_at', // 프로젝트 목록 정렬
  bookmarkListOrder: '-updated_at', // 즐겨찾기 목록 정렬
  trashListOrder: '-updated_at', // 휴지통 목록 정렬
  multiTableDataListOrder: 'name', // 데이터 목록 정렬
  rpaListOrder: 'name', // rpa 목록 정렬
  logOrder: '-created_at', // api log 목록 정렬
  aiAgentTimeValue1: 'created_at', // AI Agent 목록 헤더 시간 관련 선택값 1
  aiAgentTimeValue2: 'last_started_time', // AI Agent 목록 헤더 시간 관련 선택값 2
  aiAgentCurrentOrder: '-created_at', // AI Agent 목록 정렬
  isFormatMode: true, // 서식 보기 관련
  isShowFunctionList: true, // 기능 목록 숨김/표시 관련
  isShowFilterArea: false, // 필터 영역 숨김/표시 관련
  isShowHiddenRpa: false, // 숨긴 워크플로우 표시 관련
  paginationLimit: 50, // 페이지네이션 limit (페이지 당) 관련
  isArrowLineBehind: false, // 워크플로우 > 화살표 뒤로 보내기
  isShowRpaBlockTimeLog: false, // 워크플로우 > 걸린 시간 표시
  workspaceDashboardList: ['rpa', 'ai-agent', 'file'], // 워크스페이스 > 대시보드 설정
  rpaDashBoardOptionValue: '-run_at', // 워크스페이스 > 대시보드 > 워크플로우 목록 정렬
  aiAgentDashBoardOptionValue: '-last_issue_time', // 워크스페이스 > 대시보드 > AI Agent 목록 정렬
  fileDashBoardOptionValue: '-created_at', // 워크스페이스 > 대시보드 > 파일 목록 정렬
  projectFilterList: [], // 프로젝트 목록 필터 관련
  selectedPermissionList: ['all_option'], // 프로젝트 목록 필터 > 내 권한 필터 관련
  dateFilterValue: 'all_option', // 프로젝트 목록 필터 > 내 접속일 필터 관련
  dateFilterStartDate: '', // 프로젝트 목록 필터 > 내 접속일 필터 관련
  dateFilterEndDate: '', // 프로젝트 목록 필터 > 내 접속일 필터 관련
  selectedOwnerList: [{ id: -1, name: '전체' }], // 프로젝트 목록 필터 > 오너 필터 관련
  selectedSharedOrganizationList: [{ id: -1, name: '전체' }], // 프로젝트 목록 필터 > 공유 대상 필터 관련
  insightListOrder: '-updated_at', // 인사이트 목록 정렬
  basicTutorialFlag: true, // 기본 튜토리얼 관련
  expireDateEndDialog: false, // 기한 만료 n일 이내인 경우 표시되는 dialog
  expireDateEndAlert: false, // 기한 만료 n일 이내인 경우 표시되는 상단 alert
  dataView: 'detail_view', // DataViewButtonGroup 사용(과거 ui)
})
